import React from "react";
import { StyleSheet, View } from "react-native";
import colors from "@constants/color";
import Text from "@components/CustomText";
import WhatsappSmall from "@assets/svg/WhatsappSmall";

const WAShareOrder = (props) => {
  const {
    icon = null,
    textColor = colors.lima,
    textStyles = {},
    waText = false,
    buttonStyles = {},
  } = props || {};

  const waIcon = icon ? icon : <WhatsappSmall style={{ marginRight: 10 }} />;
  const color = textColor ? textColor : colors.lima;

  return (
    <View style={[styles.shareButton, buttonStyles]}>
      {waIcon}
      <Text style={{ color, ...textStyles }}>
        {waText ? waText : "शेयर करें"}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  shareButton: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
  },
});

export default WAShareOrder;
